import type { ExchangeCodeParams, SyncUserParams } from '@/api/google';
import { GoogleApi } from '@/api/google';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { googleKeys } from './google.keys';

export function useExchangeCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: ExchangeCodeParams) => GoogleApi.exchangeCode(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleKeys.all });
    },
  });
}

export function useDisconnect() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => GoogleApi.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleKeys.all });
    },
  });
}

export function useLogoutAndForget() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => GoogleApi.logoutAndForget(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleKeys.all });
    },
  });
}

export function useSyncUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: SyncUserParams) => GoogleApi.syncUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: googleKeys.all });
    },
  });
}

export function useConnectToken() {
  return useMutation({
    mutationFn: () => GoogleApi.getConnectToken(),
  });
}
